// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    company: {
      display: 'flex',
      paddingTop: 20,
      paddingBottom: 10,
      paddingRight: 0,
      paddingLeft: 10,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    companyCloseDrawer: {
      paddingLeft: 0,
      justifyContent: 'center',
    },
    logoContainer: {
      minWidth: 50,
      width: 50,
      height: 50,
      position: 'relative',
      cursor: 'pointer',
      borderRadius: '10%',
      border: 'none',
      backgroundColor: theme.palette.colors.green,
      '& img': {
        position: 'absolute',
        borderRadius: '10%',
        height: '100%',
        width: '100%',
        border: 'none',
        transition: theme.transitions.create('all', {
          easing: theme.transitions.easing.sharp,
          duration: 800,
        }),
      },
    },
    logoUpdate: {
      padding: '20%',
      boxSizing: 'border-box',
      background: 'rgba(0, 0, 0, 0.6)',
    },
    hiddenImage: {
      opacity: 0,
    },
    companyLabel: {
      fontSize: 16,
      fontWeight: 'bold',
      marginLeft: 7,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: theme.palette.colors.white,
    },
    expand: {
      fill: theme.palette.colors.white,
    },
    expandIcon: {
      display: 'none',
    },
    settings: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.colors.white,
    },
    settingsDawerClose: {
      marginLeft: 0,
    },
    settingsIcon: {
      width: 35,
      height: 30,
      color: theme.palette.colors.white,
    },
    marginIcon: {
      marginLeft: 5,
    },
    settingsText: {
      fontSize: 14,
      marginTop: 3,
      textTransform: 'none',
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
    },
  }),
);

export default useStyles;
